// 主动安全报警类型
export const AsAlarmType = [
  { label: 'ADAS', value: 100 },
  { label: 'DSM', value: 101 },
  { label: 'TPMS', value: 102 },
  { label: 'BSD', value: 103 }
]

// 主动安全报警级别
export const AlarmLevel = [
  { label: '一级', value: 0x01 },
  { label: '二级', value: 0x02 }
]

// 主动安全报警状态
export const AlarmInfoState = [
  { label: '不可用', value: 0x00 },
  { label: '开始标志', value: 0x01 },
  { label: '结束标志', value: 0x02 }
]

// DSM报警类型
export const DsmAlarmInfoAlarmType = [
  { label: '疲劳驾驶', value: 0x1 },
  { label: '接打电话报警', value: 0x2 },
  { label: '抽烟报警', value: 0x3 },
  { label: '不目视前方报警', value: 0x4 },
  { label: '驾驶员异常报警', value: 0x5 },
  { label: '探头遮挡报警', value: 0x6 },
  { label: '超时驾驶报警', value: 0x8 },
  { label: '未系安全带报警', value: 0x0A },
  { label: '红外阻断型墨镜失效报警', value: 0x0B },
  { label: '双脱把报警', value: 0x0C },
  { label: '玩手机报警', value: 0x0D },
  { label: '自动抓拍事件', value: 0x10 },
  { label: '驾驶员变更事件', value: 0x11 }
]

// ADAS报警类型
export const AdasAlarmInfoAlarmType = [
  { label: '前向碰撞报警', value: 0x01 },
  { label: '车道偏离报警', value: 0x02 },
  { label: '车距过近报警', value: 0x03 },
  { label: '行人碰撞报警', value: 0x04 },
  { label: '频繁变道报警', value: 0x05 },
  { label: '道路标识超限报警', value: 0x06 },
  { label: '障碍物报警', value: 0x07 },
  { label: '道路标志识别事件', value: 0x10 },
  { label: '主动抓拍事件', value: 0x11 },
  { label: '实线变道报警', value: 0x12 },
  { label: '车厢过道行人检测报警', value: 0x13 }
]

// ADAS偏离类型
export const AdasAlarmInfoDeviateType = [
  { label: '左侧偏离', value: 0x01 },
  { label: '右侧偏离', value: 0x02 }
]

// ADAS道路标志类型
export const AdasAlarmInfoSignType = [
  { label: '限速标志', value: 0x01 },
  { label: '限高标志', value: 0x02 },
  { label: '限重标志', value: 0x03 },
  { label: '禁行标志', value: 0x04 },
  { label: '禁停标志', value: 0x05 }
]

// BSD报警类型
export const BsdAlarmInfoAlarmType = [
  { label: '后方接近报警', value: 0x01 },
  { label: '左侧后方接近报警', value: 0x02 },
  { label: '右侧后方接近报警', value: 0x03 }
]

// TPMS报警类型
export const TpmsAlarmInfoAlarmType = [
  { label: '定时上报胎压', value: 0x01 },
  { label: '胎压过高报警', value: 0x02 },
  { label: '胎压过低报警', value: 0x04 },
  { label: '胎温过高报警', value: 0x08 },
  { label: '传感器异常报警', value: 0x10 },
  { label: '胎压不平衡报警', value: 0x20 },
  { label: '慢漏气报警', value: 0x40 },
  { label: '电池电量低报警', value: 0x80 }
]

// 定位设备安装情况
export const HasBindServiceDevicesType = [
  { label: '无定位设备', value: 0x00 },
  { label: '已安装设备', value: 0x01 }
]

export default {
  AsAlarmType,
  AlarmLevel,
  AlarmInfoState,
  DsmAlarmInfoAlarmType,
  AdasAlarmInfoAlarmType,
  AdasAlarmInfoDeviateType,
  AdasAlarmInfoSignType,
  BsdAlarmInfoAlarmType,
  TpmsAlarmInfoAlarmType,
  HasBindServiceDevicesType
}
